import React from "react"
import { WebSource } from "../../../../../model/types"
import { useNana } from "../../../../hooks/useNana"
import * as DateFns from "date-fns"
import Autocomplete, {
  AutocompleteOptions,
  AutocompleteResult,
} from "../../../../components/autocomplete"
import Model from "../../../../../model/model"
import { NavigationHistoryState } from "../../mosaic"

const deschemeUrl = (url: string) => {
  return url.replace(/https?:\/\//, "")
}

const filterSources = (filter: string, model: Model) =>
  model
    .getSources()
    .filter((source) => {
      return (
        (source.url && source.url.toLowerCase().includes(filter.toLowerCase())) ||
        (source.name &&
          source.name.toLowerCase().includes(filter.toLowerCase())) ||
        (source.author &&
          source.author.toLowerCase().includes(filter.toLowerCase())) ||
        (source.type && source.type.toLowerCase().includes(filter.toLowerCase()))
      )
    })
    .sort((a, b) => {
      if (a.lastUsedAt && b.lastUsedAt) {
        return DateFns.compareAsc(b.lastUsedAt, a.lastUsedAt)
      } else if (a.lastUsedAt) {
        return -1
      } else if (b.lastUsedAt) {
        return 1
      } else {
        return DateFns.compareAsc(a.createdAt, b.createdAt)
      }
    })
    .reverse()

const SourceAutocomplete = ({
  connect,
}: {
  connect: (result: AutocompleteResult<WebSource>, filter: string) => boolean
}) => {
  const { model } = useNana()

  const closeWithEvent = () => {
    NavigationHistoryState.set_open_location(null)
  }

  const options: AutocompleteOptions<WebSource> = {
    select: connect,
    showAbove: true,
    placeholder: "Paste URL or type to search for existing source...",
    emptyMessage: "No sources found. Enter URL and press enter to create new.",
    fetchItems: (filter: string): WebSource[] => {
      return filterSources(filter, model)
    },
    renderItem: (result: AutocompleteResult<WebSource>) => {
      if (result.type == "none") {
        return <div>None</div>
      } else {
        const item = result.item
        return (
          <div className="block overflow-hidden text-ellipsis whitespace-nowrap cursor-pointer">
            <div>{item.name || item.url || "Source"}</div>
            <div className="text-xs text-gray-400">{item.url || item.type}</div>
          </div>
        )
      }
    },
    onEscape: closeWithEvent,
    inputStyle: "inset",
  }
  return <Autocomplete {...options} />
}

export default SourceAutocomplete
